export const controlPointStatus = {
  0: "Не завершено",
  1: "Завершено",
  2: "Завершено преждевременно",
  3: "Завершено с опозданием",
};
